export const getFacetValuesToDisplay = ({
  isFiltered,
  facet,
  filteredFacetValues
}) => (isFiltered ? filteredFacetValues : facet.facetValues);
